import OrderedTicket, {
    OrderedTicketItem,
} from 'components/shared/OrderedTicket'

interface OrderedCabanaProps {
    id?: string
    name?: string
    description?: string
    price?: number
    isDisabled?: boolean
    onEdit: () => void
    onDelete: (id: string) => void
    'data-testid'?: string
}

const OrderedSpa = ({
    id,
    name,
    description,
    price,
    isDisabled,
    onDelete,
    onEdit,
    'data-testid': testId,
}: OrderedCabanaProps) => {
    const handleDelete = () => {
        id && onDelete(id)
    }

    const handleEdit = () => {
        onEdit()
    }

    const spaItem: OrderedTicketItem = {
        text: name,
        date: description,
    }

    // TODO: used common OrderedTicket component, but it needs refactoring
    return !id || !name || !description || price === undefined ? null : (
        <OrderedTicket
            items={[spaItem]}
            price={price}
            onDelete={handleDelete}
            onEdit={handleEdit}
            isActionError={false}
            hasCtaDisabled={isDisabled}
            hasLongerName
            id={id}
            testIdPrefix={testId}
        />
    )
}

export default OrderedSpa
